export type PortaChave = 'divulgar' | 'ingresso' | 'inscricoes' | 'rifa';

export interface Porta {
  chave: PortaChave;
  icone: string;
  titulo: string;
  descricao: string;
  trabalho: string;
  para: string;
}

export const PORTAS: Porta[] = [
  {
    chave: 'divulgar',
    icone: 'ri-megaphone-line',
    titulo: 'Divulgar um evento',
    descricao: 'Grátis, entrada franca. É só avisar as pessoas.',
    trabalho: '1 tela',
    para: '/criar/divulgar',
  },
  {
    chave: 'ingresso',
    icone: 'ri-ticket-2-line',
    titulo: 'Vender ingresso',
    descricao: 'Show, jantar, festa. Com pagamento.',
    trabalho: '2 telas',
    para: '/criar/ingresso',
  },
  {
    chave: 'inscricoes',
    icone: 'ri-file-list-3-line',
    titulo: 'Abrir inscrições',
    descricao: 'Acampamento, retiro, curso. Com ficha e vagas.',
    trabalho: '2 telas, o resto depois',
    para: '/criar/inscricoes',
  },
  {
    chave: 'rifa',
    icone: 'ri-coupon-3-line',
    titulo: 'Fazer uma ação entre amigos',
    descricao:
      'A ação entre amigos ajuda a arrecadar: cada pessoa que participa concorre aos prêmios, e o que entra ajuda a pagar a obra.',
    trabalho: '3 telas',
    para: '/criar/sorteio',
  },
];

interface ConfigPorta {
  categoria?: string;
  forma?: 'inscricao' | 'ingresso';
  para?: string;
}

// Cada porta abre o fluxo correspondente já com as chavinhas ligadas.
// A categoria é só um padrão por baixo; dá para trocar depois nos ajustes.
export const CONFIG_PORTA: Record<PortaChave, ConfigPorta> = {
  divulgar: { categoria: 'outro', forma: 'inscricao' },
  ingresso: { categoria: 'show', forma: 'ingresso' },
  inscricoes: { categoria: 'retiro', forma: 'inscricao' },
  rifa: { para: '/sorteio/nova' },
};

export function iconeDoEvento(categoria: string | null): string {
  switch (categoria) {
    case 'show':
    case 'congresso':
      return 'ri-ticket-2-line';
    case 'acampamento':
    case 'retiro':
    case 'curso':
      return 'ri-file-list-3-line';
    case 'rifa':
      return 'ri-coupon-3-line';
    default:
      return 'ri-megaphone-line';
  }
}